export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8982.49b3bc5a.jpg";